import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../../img/axxess-logo.png'
import _imports_1 from '../../../img/Axxess_Intelligence_Logo.svg'


const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "d-lg-flex w-100"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "main-header-div" }
const _hoisted_6 = { class: "dashboard-header" }
const _hoisted_7 = { class: "clinician-level-two position-relative" }
const _hoisted_8 = {
  key: 0,
  class: "ai-logo bg-white d-flex align-items-center m-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "m-0 p-0",
  alt: ""
}, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", { class: "ai-premium-btn me-md-2" }, "Premium", -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { id: "aside" }
const _hoisted_13 = {
  key: 0,
  id: "App__Header"
}
const _hoisted_14 = { id: "App__Main" }
const _hoisted_15 = { class: "h-100" }
const _hoisted_16 = { class: "h-100" }
const _hoisted_17 = { class: "foot-class" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowPopupNotification = _resolveComponent("WindowPopupNotification")!
  const _component_DashboardHeader = _resolveComponent("DashboardHeader")!
  const _component_PlannerLevelTwo = _resolveComponent("PlannerLevelTwo")!
  const _component_AppNav = _resolveComponent("AppNav")!
  const _component_AgencyList = _resolveComponent("AgencyList")!
  const _component_CentralNav = _resolveComponent("CentralNav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_EmployeeList = _resolveComponent("EmployeeList")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PatientList = _resolveComponent("PatientList")!
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")!
  const _component_DynamicDialog = _resolveComponent("DynamicDialog")!
  const _component_Notification = _resolveComponent("Notification")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WindowPopupNotification),
    _createElementVNode("section", { id: _ctx.appId }, [
      (_ctx.isLoggedIn && _ctx.showAside)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "axxess-logo-vue cursor-pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToClinician && _ctx.navigateToClinician(...args)))
            }, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_DashboardHeader)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.showLogo && !_ctx.isHelpPage)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_11))
                  : _createCommentVNode("v-if", true),
                (!_ctx.isAppLoading)
                  ? (_openBlock(), _createBlock(_component_PlannerLevelTwo, {
                      key: 1,
                      router: _ctx.router,
                      showIcons: true,
                      "agencies-list": _ctx.agenciesList,
                      "show-patients": _ctx.showPatients,
                      "onUpdate:show-patients": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showPatients) = $event)),
                      "show-employees": _ctx.showEmployees,
                      "onUpdate:show-employees": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showEmployees) = $event)),
                      "open-agency-nav": _ctx.openAgencyNav,
                      "onUpdate:open-agency-nav": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.openAgencyNav) = $event))
                    }, null, 8 /* PROPS */, ["router", "agencies-list", "show-patients", "show-employees", "open-agency-nav"]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.isLoggedIn && _ctx.showAside ? 'd-flex' : ''}`)
      }, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isLoggedIn && _ctx.showAside)
            ? (_openBlock(), _createElementBlock("aside", {
                key: 0,
                id: "App__Aside",
                class: _normalizeClass(_ctx.openAgencyNav ? 'show-sidenav' : 'hide-sidenav')
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(`w-100 action-list ${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`)
                }, [
                  _createVNode(_component_AppNav, { areRolesLoaded: _ctx.areRolesLoaded }, null, 8 /* PROPS */, ["areRolesLoaded"]),
                  _createVNode(_component_AgencyList, {
                    isLoading: _ctx.isLoading,
                    groupedAgencies: _ctx.groupedAgencies,
                    hasError: _ctx.hasError,
                    onLoadAgencies: _ctx.loadAgencies
                  }, null, 8 /* PROPS */, ["isLoading", "groupedAgencies", "hasError", "onLoadAgencies"])
                ], 2 /* CLASS */)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ]),
        (_ctx.isLoggedIn && !_ctx.showAside)
          ? (_openBlock(), _createElementBlock("header", _hoisted_13, [
              _createVNode(_component_CentralNav, {
                areRolesLoaded: _ctx.areRolesLoaded,
                showEmployees: _ctx.showEmployees,
                "onUpdate:showEmployees": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showEmployees) = $event)),
                showPatients: _ctx.showPatients,
                "onUpdate:showPatients": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showPatients) = $event))
              }, null, 8 /* PROPS */, ["areRolesLoaded", "showEmployees", "showPatients"])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("main", _hoisted_14, [
          (_ctx.startApp)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_router_view),
                (_ctx.showPatients || _ctx.showEmployees)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_Dialog, {
                        visible: _ctx.showEmployees,
                        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showEmployees) = $event)),
                        class: "dashboard-dialog",
                        position: "bottomright",
                        modal: "",
                        "show-header": false,
                        style: { height: '100vh' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_EmployeeList, {
                              showEmployees: _ctx.showEmployees,
                              "onUpdate:showEmployees": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showEmployees) = $event))
                            }, null, 8 /* PROPS */, ["showEmployees"])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["visible"]),
                      _createVNode(_component_Dialog, {
                        visible: _ctx.showPatients,
                        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showPatients) = $event)),
                        class: "dashboard-dialog",
                        position: "bottomright",
                        modal: "",
                        "show-header": false,
                        style: { height: '100vh' }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_PatientList, {
                              showPatients: _ctx.showPatients,
                              "onUpdate:showPatients": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showPatients) = $event))
                            }, null, 8 /* PROPS */, ["showPatients"])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["visible"])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ], 2 /* CLASS */)
    ], 8 /* PROPS */, _hoisted_1),
    _createVNode(_component_LoadingIndicator, { "is-loading": _ctx.isAppLoading }, null, 8 /* PROPS */, ["is-loading"]),
    _createVNode(_component_DynamicDialog),
    (_ctx.isAnyPremiumAgency && _ctx.hasAxxessConnectPermission)
      ? (_openBlock(), _createBlock(_component_Notification, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("footer", _hoisted_17, [
      _createTextVNode(" Axxess © " + _toDisplayString(new Date().getFullYear()) + " | ", 1 /* TEXT */),
      _withDirectives((_openBlock(), _createElementBlock("span", null, [
        _createTextVNode("Release Version: " + _toDisplayString(_ctx.releaseVer), 1 /* TEXT */)
      ])), [
        [_directive_tooltip, { title: ` Released on ${_ctx.releaseTime}` }]
      ]),
      _createTextVNode(" | Environment: " + _toDisplayString(_ctx.releaseEnv) + " | Built in Dallas, Texas ", 1 /* TEXT */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}